// A number in the display voice (kit-sheet `.t-disp`, `.score`, `.ing`):
// tabular numerals, so a counter ticking from 9 to 10 does not shift the
// characters beside it.
//
// **No font size.** The role is used at 26px in the type specimen, 15px on the
// score pill and 13px on an ingot count — size is the call site's, weight and
// numerals are the role's.
//
// The colour override is `tone`, not `color`: `color` is a real HTML attribute
// and would land on the DOM node as one.

import { styled } from "@mui/material/styles";

export const StatCounter = styled("span", {
  shouldForwardProp: (prop: string) => prop !== "tone"
})<{ tone?: string }>(({ theme, tone }) => ({
  fontFamily: theme.kit.font.display,
  fontWeight: 700,
  fontVariantNumeric: "tabular-nums",
  letterSpacing: ".04em",
  color: tone ?? theme.kit.color.brand
}));
